import { BlockCard, DonutChart } from "../primitives";
import { BlockBaseProps, Slice } from "../types";
import AssignmentPipelineBlockSkeleton from "./Skeleton";
import styles from "./style.module.scss";

interface AssignmentPipelineBlockProps extends BlockBaseProps {
  /** Not started / In progress / Completed / Overdue, with raw counts. */
  stages: Slice[];
  title?: string;
  /** Caption under the total, e.g. "3% done". */
  centerCaption?: string;
  centerLabel?: string;
}

/** Where assigned books currently sit, as a donut with a counted legend. */
function AssignmentPipelineBlock({
  stages,
  title = "Assignment pipeline",
  centerCaption,
  centerLabel = "Assigned",
  loading,
  empty,
  className,
}: AssignmentPipelineBlockProps) {
  if (loading) {
    return (
      <AssignmentPipelineBlockSkeleton
        count={stages.length || 4}
        className={className}
      />
    );
  }

  const total = stages.reduce(
    (sum, stage) => sum + (Number(stage.count) || 0),
    0
  );

  return (
    <BlockCard title={title} headerTight empty={empty} className={className}>
      <div className={styles.body}>
        <DonutChart
          slices={stages}
          size={130}
          trackColor={null}
          center={
            <>
              <span className={styles.total}>{total}</span>
              <span className={styles.totalLabel}>{centerLabel}</span>
              {centerCaption && (
                <span className={styles.totalCaption}>{centerCaption}</span>
              )}
            </>
          }
        />

        <div className={styles.legend}>
          {stages.map((stage) => (
            <div key={stage.label} className={styles.legendRow}>
              <span className={styles.swatch} style={{ background: stage.color }} />
              <span className={styles.legendLabel}>{stage.label}</span>
              <span className={styles.legendCount}>{stage.count}</span>
              <span className={styles.legendPct}>{`${Math.round(stage.share)}%`}</span>
            </div>
          ))}
        </div>
      </div>
    </BlockCard>
  );
}

export default AssignmentPipelineBlock;
